import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  user: any = {};
  token: string;
  step: number = 1; // 1: username, 2: OTP, 3: new password
  otpTimer: number = 180; // 3 minutes
  timerInterval: any;
  userId: number;
  otpToken: string;

  constructor(private route: ActivatedRoute, private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.token = params.id;
    });
  }

  sendOTP() {
    if (!this.user.username) {
      this._flashMessagesService.show('Please enter username', { cssClass: 'alert-danger' });
      return;
    }

    this.loginservice.sendPasswordResetOTP(this.user.username)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.userId = data['user_id'];
            this.step = 2;
            this.startTimer();
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error sendPasswordResetOTP API');
          this._flashMessagesService.show('Error sending OTP', { cssClass: 'alert-danger' });
        }
      );
  }

  verifyOTP() {
    if (!this.user.otp) {
      this._flashMessagesService.show('Please enter OTP', { cssClass: 'alert-danger' });
      return;
    }

    this.loginservice.verifyPasswordResetOTP(this.userId, this.user.otp)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.otpToken = data['otp_token'];
            this.step = 3;
            this.stopTimer();
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error verifyPasswordResetOTP API');
          this._flashMessagesService.show('Error verifying OTP', { cssClass: 'alert-danger' });
        }
      );
  }

  resetPassword() {
    if (!this.user.password || !this.user.password2) {
      this._flashMessagesService.show('Please fill all fields', { cssClass: 'alert-danger' });
      return;
    }

    if (this.user.password !== this.user.password2) {
      this._flashMessagesService.show('Passwords do not match', { cssClass: 'alert-danger' });
      return;
    }

    this.loginservice.resetPasswordWithOTP(this.otpToken, this.user.password)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
            this.step = 1;
            this.user = {};
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error resetPasswordWithOTP API');
          this._flashMessagesService.show('Error resetting password', { cssClass: 'alert-danger' });
        }
      );
  }

  resendOTP() {
    this.sendOTP();
  }

  startTimer() {
    this.otpTimer = 180;
    this.timerInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer <= 0) {
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  goBack() {
    if (this.step > 1) {
      this.step--;
      if (this.step === 1) {
        this.stopTimer();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/changepassword/changepassword.component.ts